document.addEventListener('DOMContentLoaded', function(){
  // Target only Static Banner 3
  document.querySelectorAll('[data-section-type="static-banner-3"] .banner__media').forEach(function(banner){
    var parentSection = banner.closest('[data-section-type="static-banner-3"]');
    if (parentSection) {
      var button = parentSection.querySelector('.button');
      if (button && button.getAttribute('href')) {
        var link = button.getAttribute('href');
        banner.addEventListener('click', function(){
          window.location.href = link;
        });
      }
    }
  });
});
